module.exports = __webpack_public_path__ + "static/2-db429b10a654339a1d3ceb6901dd545a.jpg";